// same name as from package http-status-codes
export const TEMPORARY_REDIRECT = 307
export const PERMANENT_REDIRECT = 301
export const MOVED_TEMPORARILY = 302
